<div class="container container-shadow pt-4 pb-5 my-4 mb-4">
  <h3 class="text-center">Stylesheet Groups</h3>
  <div class="row mb-4">
    <div class="col-md-4">
      <app-badge badgeType="secondary" [pillBadge]="true">{{ styleSheetGroupsMaxCount }} Groups</app-badge>
    </div>
    <div class="col-md-4 offset-md-4">
      <div class="input-group">
        <input name='name' type="text" class="form-control" placeholder="Name" (keyup)="setSearchTerm($event)" />
        <div class="input-group-append" (click)="searchStyleSheetGroups()">
          <button class="btn btn-outline-secondary" type="button"><i class="fas fa-search"></i></button>
        </div>
      </div>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-md-9">
      <table class="table">
        <thead>
          <tr>
            <th>S.No.</th>
            <th>Name</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let styleSheetGroup of styleSheetGroups">
            <td>{{ styleSheetGroup.id }}</td>
            <td>{{ styleSheetGroup.name }}</td>
            <td (click)="updateStyleSheetGroup(styleSheetGroup.id, styleSheetGroup.name)"><i class="far fa-edit"></i></td>
            <td>
              <button type="button" class="btn btn-danger btn-sm" (click)="deleteStyleSheetGroup(styleSheetGroup.id, styleSheetGroup)" [disabled]="styleSheetGroup.isDeleting">
                {{ styleSheetGroup.isDeleting ? 'Deleting' : 'Delete' }}<span *ngIf="styleSheetGroup.isDeleting">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-3">
      <h4>Add Stylesheet Group</h4>
      <form>
        <div class="form-group">
          <label for="stylesheet-group-name">Name</label>
          <input name='stylesheet_group_name' type="text" class="form-control" id="stylesheet-group-name" (keyup)="getstyleSheetGroupFormInput($event)" value="{{ styleSheetGroupFormInput }}" />
        </div>
        <div class="form-group" *ngIf="!shouldEdit">
          <button type="button" class="btn btn-primary btn-sm" (click)="createStyleSheetGroup()" [disabled]="isCreating">
            {{ isCreating ? 'Adding Group' : 'Add Group' }}<span *ngIf="isCreating">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
          </button>
        </div>
        <div class="form-row" *ngIf="shouldEdit">
          <div class="form-group col-md-6">
            <button type="button" class="btn btn-primary btn-sm btn-block" (click)="makeUpdateStyleSheetGroup()" [disabled]="isUpdating">
              {{ isUpdating ? 'Updating' : 'Update' }}<span *ngIf="isUpdating">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
            </button>
          </div>
          <div class="form-group col-md-6">
            <button type="button" class="btn btn-secondary btn-sm btn-block" (click)="shouldEdit = false; styleSheetGroupFormInput = ''">Cancel</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <pagination
    (pageChanged)="loadStyleSheetGroups($event)"
    class="pagination-sm"
    [boundaryLinks]="true"
    [totalItems]="styleSheetGroupsMaxCount"
    [maxSize]="paginateParams.per_page"
    [(ngModel)]="paginateParams.page"
    [itemsPerPage]="paginateParams.per_page"
    previousText="&lsaquo;"
    nextText="&rsaquo;"
    firstText="&laquo;"
    lastText="&raquo;"
  ></pagination>
</div>
